/**
 * WidgetLink - переиспользуемый компонент ссылки для виджета
 *
 * Использует CSS переменные из widget-tokens.css для стилизации.
 * Ссылки открываются в новом табе с безопасными атрибутами.
 */

import { memo } from 'react';
import PropTypes from 'prop-types';
import './WidgetLink.css';

export const WidgetLink = memo(({ href, children, className = '', variant = 'default' }) => {
  const linkClassName = [
    'widget-link',
    variant === 'muted' && 'widget-link--muted',
    className,
  ].filter(Boolean).join(' ');

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={linkClassName}
    >
      {children}
    </a>
  );
});

WidgetLink.displayName = 'WidgetLink';

WidgetLink.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'muted']),
};
